import { Component, OnInit } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';
import { OrdemServicoService } from '../service/ordem-servico.service';
import { AtivoParamModel } from '../model/ativo-param.model';
import { ClienteModel } from '../model/cliente.model';
import { AdvGrowlService } from 'primeng-advanced-growl';
import { constants } from './../app-constants';
import { PropertiesLocales } from '../util/properties-locale';
import {QrCodeDialogComponent} from '../qr-code-dialog/qr-code-dialog.component';
import {DialogService} from 'primeng/api';
import {DataService} from '../service/data.service';
import {NgxUiLoaderService} from "ngx-ui-loader";

@Component({
  selector: 'app-criar-osativo',
  templateUrl: './criar-osativo.component.html',
  styleUrls: ['./criar-osativo.component.css'],
  styles: [
    '::ng-deep  .ui-orderlist .ui-orderlist-list-container{ width: 75%; margin-left:12.5%; margin-right:5% }',
    '::ng-deep .ui-orderlist .ui-orderlist-controls{ display: none }',
    '::ng-deep .ui-orderlist .ui-orderlist-list{ height: 20em }',
    '::ng-deep .ui-panel { width: 75%; margin-left:12%; margin-right:12%  }',
    `.label-cliente { font-size: 16px;  padding-bottom: 7px; padding-top: 7px;
      font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: bold;}
     .header-cliente { color: cornflowerblue; }
     .button-right-position { margin-top : 10px; margin-left : 78%; }`
  ]
})
export class CriarOSAtivoComponent implements OnInit {

  ativoParam: AtivoParamModel = new AtivoParamModel();
  clienteModel: ClienteModel = new ClienteModel();
  properties: PropertiesLocales = new PropertiesLocales();
  filterAtivo: any;
  ativo: any;
  ativoSelected: any;
  selectedAtivo: any;
  ativos: Array<any> = [];
  numberPage = 1;
  cols: any[];
  basePath: string;
  firstMessage = false;
  displayModal = false;

  constructor(private loadingBar: NgxUiLoaderService,
              private ordemServicoService: OrdemServicoService,
              private advGrowlService: AdvGrowlService,
              private pathLocationStrategy: PathLocationStrategy,
              public dialogService: DialogService,
              private data: DataService) {
  }

  ngOnInit() {
    this.buildDynamicHeaders();
    this.clienteModel = this.ativoParam.contratoId = JSON.parse(localStorage.getItem(constants.clienteKey));
    const ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    if (ativo !== null) {
      this.ativos.push(ativo);
    }
    this.data.currentMessage.subscribe(message => {
      if (message === 'criar-os') {
        this.firstMessage = true;
        return;
      } else if (this.firstMessage === true) {
        this.clearGridAtivos();
        const ativoQRCode = JSON.parse(message);
        this.ativos.push(ativoQRCode[0]);
        this.firstMessage = false;
      }
    });
  }

  buscarQRCode() {
    this.displayModal = false;
    const ref = this.dialogService.open(QrCodeDialogComponent, {
      header: 'Busca por QR Code',
      width: '70%',
      contentStyle: {'max-height': '350px', 'overflow': 'auto'}
    });
  }

  public findByAtivos() {
    this.loadingBar.start();
    this.ativoParam.contratoId = this.clienteModel.clienteContratoId;
    if (this.filterAtivo == null) {
      this.ativoParam.descricao = '';
    } else {
      this.ativoParam.descricao = this.filterAtivo;
    }
    this.clearGridAtivos();
    this.ordemServicoService.listarAtivos(this.ativoParam)
    .subscribe(response => {
      this.numberPage++;
      this.onSuccess(response.ativosOut);
    });
  }

  onSuccess(res) {
    this.loadingBar.stop();
    if (res) {
      res.forEach(prAtivo => {
        this.ativos.push(prAtivo);
      });
    }
  }

  selecionarAtivo($event) {
    this.ativoSelected = $event;
    localStorage.setItem(constants.ativoKey, JSON.stringify(this.ativoSelected));
  }

  clearGridAtivos() {
    localStorage.setItem(constants.ativoKey, JSON.stringify(null));
    this.ativos = [];
  }

  buildDynamicHeaders() {
    this.basePath = this.pathLocationStrategy.getBaseHref();
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7).replace('/', '').toString();

    if (!local.match(uri)) { // prevalece o locale definido na URL
      local = uri.replace('/', '');
    }

    if (local === 'pt') {
      this.cols = [
        { field: 'numeroSerie', header: this.properties.items_steps_pt[5].label_cmp_ativo_nroserie },
        { field: 'numeroPatrimonio', header: this.properties.items_steps_pt[6].label_cmp_ativo_nropatrimonio },
        { field: 'descricaoTipoEquipamento', header: this.properties.items_steps_pt[7].label_cmp_ativo_equipamento },
        { field: 'ambiente', header: this.properties.items_steps_pt[8].label_cmp_ativo_ambientes }
      ];
    }

    if (local === 'es') {
      this.cols = [
        { field: 'numeroSerie', header: this.properties.items_steps_es[5].label_cmp_ativo_nroserie },
        { field: 'numeroPatrimonio', header: this.properties.items_steps_es[6].label_cmp_ativo_nropatrimonio },
        { field: 'descricaoTipoEquipamento', header: this.properties.items_steps_es[7].label_cmp_ativo_equipamento },
        { field: 'ambiente', header: this.properties.items_steps_es[8].label_cmp_ativo_ambientes }
      ];
    }

    if (local === 'en') {
      this.cols = [
        { field: 'numeroSerie', header: this.properties.items_steps_en[5].label_cmp_ativo_nroserie },
        { field: 'numeroPatrimonio', header: this.properties.items_steps_en[6].label_cmp_ativo_nropatrimonio },
        { field: 'descricaoTipoEquipamento', header: this.properties.items_steps_en[7].label_cmp_ativo_equipamento },
        { field: 'ambiente', header: this.properties.items_steps_en[8].label_cmp_ativo_ambientes }
      ];
    }
  }
}
